'use strict';/* global define, console */define('modules/core/modules/app/directives/app-sidebar-nav/controller',['require','exports','module','angular'],function(require,exports,module){'use strict';
     controller.$inject = ["$scope", "$state", "$injector", "Me", "roleCheck", "ROLES", "_"];var ng=require('angular');// @ngInject
function controller($scope,$state,$injector,Me,roleCheck,ROLES,_){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.me=Me.get();ctrl.deactivatedSections=$scope.deactivatedSections||[];ctrl.isAdmin=$scope.isAdmin;ctrl.isCustomFormsEditor=$scope.isCustomFormsEditor;ctrl.isCompanyAdmin=ctrl.me.roles&&roleCheck(ROLES.admin);ctrl.isCanBeSupervisor=ctrl.me.roles&&roleCheck(ROLES.wannabe);// ---
var stateWatcher=$scope.$watch(function(){return $scope.regex;},function(newValue){if(newValue){ctrl.states=_getStates(newValue);if(ctrl.deactivatedSections&&ctrl.deactivatedSections.length>0){ctrl.states=ctrl.states.filter(function(menu){return ctrl.deactivatedSections.some(function(result){return menu.name.split('.')[2]!==result.deactivatedSection.name;});});}stateWatcher();}});/**
     * Get application states filtered and sorted by
     * user role, state type and menu order
     *
     * @param {String} - RegEx for testing the type of the state
     * @return {Array} - Filtered application states
     *
     * @private
     */function _getStates(regex){return $state.get().filter(function(state){return regex.test(state.name);}).filter(_visible).sort(_sortOrder);}/**
     * Helper function to exclude the abstrated states
     * and to get only these that contains the menu properties
     *
     * @param {Object} - Nav menu item candidate
     * @return {Array} - Filtered admin menu items

     * @private
     */function _visible(state){if(state.abstract||!(state.meta&&state.meta.menu)){return false;}if(ng.isFunction(state.meta.menu)){return $injector.invoke(state.meta.menu);}return state.meta.menu;}/**
     * Helper function to compare the order property
     * of two menu items in order to sort them
     *
     * @param {Object}  - Menu object
     * @param {Object}  - Menu object
     * @return {Number} - The result index

     * @private
     */function _sortOrder(menuA,menuB){if(menuA.meta.order>menuB.meta.order){return 1;}if(menuA.meta.order<menuB.meta.order){return-1;}return 0;}}module.exports=controller;});
